// extracted by mini-css-extract-plugin
module.exports = {"CallNotes":"CallNotes-module__CallNotes___3gqEv","NoteList":"CallNotes-module__NoteList___2ATZy"};